import {
  GET_RECIPIENTS_START,
  GET_RECIPIENTS_SUCCESS,
  GET_RECIPIENTS_FAIL,
  GET_MORE_RECIPIENTS_START,
  GET_MORE_RECIPIENTS_SUCCESS,
  GET_MORE_RECIPIENTS_FAIL,
  GET_ALL_RECIPIENTS_START,
  GET_ALL_RECIPIENTS_SUCCESS,
  GET_ALL_RECIPIENTS_FAIL,
  CLEAR_RECIPIENTS,
  GET_PERMITTED_USERS_START,
  GET_PERMITTED_USERS,
  GET_PERMITTED_USERS_SUCCESS,
} from 'actions/eventDetails';
import { getListPageSuccessNewData } from '../utils';

export const defaultState = {
  error: false,
  loading: true,
  data: [],
  permittedUsers: [],
  count: 0,
  total: 0,
  links: {},
  sortBy: 'DELIVERY_DATE',
  sortOrder: 'ASCENDING',
};

export default function recipients(state = defaultState, action) {
  const { type, payload } = action;

  switch (type) {
    case CLEAR_RECIPIENTS: {
      return { ...defaultState };
    }
    case GET_ALL_RECIPIENTS_START:
    case GET_RECIPIENTS_START: {
      return {
        ...defaultState,
        error: false,
        loading: true,
        ...action.payload,
      };
    }
    case GET_ALL_RECIPIENTS_SUCCESS:
    case GET_RECIPIENTS_SUCCESS: {
      return {
        ...state,
        error: false,
        loading: false,
        loadingPermittedUsers: false,
        data: payload?.status
          ? { ...state.data }
          : {
              ...payload,
              data: getListPageSuccessNewData(
                state.data,
                payload.data,
                payload.links,
              ),
            },
      };
    }
    case GET_ALL_RECIPIENTS_FAIL:
    case GET_RECIPIENTS_FAIL: {
      return {
        ...state,
        error: payload.json,
        loading: false,
        loadingPermittedUsers: false,
      };
    }
    case GET_PERMITTED_USERS_START: {
      return {
        ...state,
        loadingPermittedUsers: true,
      };
    }
    case GET_PERMITTED_USERS:
    case GET_PERMITTED_USERS_SUCCESS: {
      return {
        ...state,
        permittedUsers: [...state.permittedUsers, ...payload.data],
        error: false,
        loadingPermittedUsers: false,
      };
    }
    case GET_MORE_RECIPIENTS_START: {
      return {
        ...state,
        loading: true,
      };
    }
    case GET_MORE_RECIPIENTS_SUCCESS: {
      return {
        ...state,
        ...payload,
        data: state.data.concat(payload.data),
        links: payload.links,
        error: false,
        loading: false,
        loadingPermittedUsers: false,
      };
    }
    case GET_MORE_RECIPIENTS_FAIL: {
      return {
        ...state,
        error: true,
        loading: false,
        loadingPermittedUsers: false,
      };
    }
    default:
      return state;
  }
}
